// 本番環境用 運営側
export const firebaseConfig = {
  apiKey: "AIzaSyDlC5vn78oQaIb3CRwJNpfmXhIwa5cCxMw",
  authDomain: "event-support-488600.firebaseapp.com",
  projectId: "event-support-488600",
  storageBucket: "event-support-488600.firebasestorage.app",
  messagingSenderId: "191839803943",
  appId: "1:191839803943:web:aeea8371ec46844ce28c02",
  measurementId: "G-QGMWVQ833V"
};